import { SET_CUSTOMER } from './actionTypes';
import { SET_LOADING } from './actionTypes'
import { SET_EXPORT_LOADING } from './actionTypes'
import { SET_LANGUAGE } from './actionTypes'
import {SET_HIGHLIGHTED} from "./actionTypes";

export const setCustomer = (customer) => ({
    type: SET_CUSTOMER,
    payload: customer,
});

export const setHighlighted = (list) => ({
    type: SET_HIGHLIGHTED,
    payload: list,
});

export const setLoading = (isLoading) => ({
    type: SET_LOADING,
    payload: isLoading,
});

export const setExportLoading = (isExportLoading) => ({
    type: SET_EXPORT_LOADING,
    payload: isExportLoading,
});

export const setLanguage = (language) => ({
    type: SET_LANGUAGE,
    payload: language,
});